module.exports = __webpack_public_path__ + "img/7.0473ef85.jpg";